<template lang="pug">
  .height-100
    .title.pt-5
      span.fw-400 {{ id ? 'Editar' : 'Nueva' }} clase
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .display-flex.mb-5
          .volver.display-flex.flex-1
            button.button.is-small(@click="volver()")
              span.icon.is-small
                i.fa.fa-arrow-left
              span Volver
          button.button.is-small.is-primary(@click="guardarClase()" :disabled="isLoadingClase")
            span.icon.is-small
              i.fa.fa-floppy-o
            span Guardar
        .body.pt-10
          .title
            .display-flex
              .control.margin-bottom-10.flex-1
                p.margin-bottom-5 Orden
                input.input.w-90(
                  type="number",
                  v-model="orden"
                  :disabled="isLoadingClase"
                )
              .control.margin-bottom-10.text-center
                p.margin-bottom-5 Activo
                input.checkbox(
                  type="checkbox",
                  v-model="activo"
                  :disabled="isLoadingClase"
                )
            .control.margin-bottom-10.flex-1
              p.margin-bottom-5 Título
              input.input(
                type="text",
                v-model="titulo"
                :disabled="isLoadingClase"
              )
            .control.margin-bottom-10
              p.margin-bottom-5 Descripción
              textarea.textarea.w-300(
                style="field-sizing: content !important;"
                v-model="descripcion"
                :disabled="isLoadingClase"
              )
            .control.margin-bottom-10.flex-1
              p.margin-bottom-5 Youtube link
              input.input(
                type="text",
                v-model="linkYT"
                @focus="e => e.target.select()"
                :disabled="isLoadingClase"
              )
            .control.margin-bottom-10.flex-1
              p.margin-bottom-5 Duración
              input.input.w-100(
                type="time",
                v-model="duracion"
                step="1"
                :disabled="isLoadingClase"
              )
        .display-flex.fdr.space-evenly.flex-wrap.pt-10
          .caja.lista-solicitud-vacaciones.contenedor-interno
            materiales-curso-lista(type="clase" @save="saveMaterial()" ref="materialesRef")
          .caja.lista-solicitud-vacaciones.contenedor-interno
            evaluaciones-curso-lista(type="clase" @save="saveEvaluacion()" ref="evaluacionesRef")
</template>

<script>
import MaterialesLista from '../components/c_materiales_lista'
import EvaluacionesLista from '../components/c_evaluaciones_lista'

import { apiGet, apiPost, apiPut, notify } from '../util/general'
export default {
  name: 'gestion-clases-virtuales-editar',
  data () {
    return {
      lista          : [],
      isLoadingClase : false,
      titulo         : '',
      descripcion    : '',
      orden          : '',
      linkYT         : '',
      duracion       : '00:00:00',
      activo         : 0
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idCurso () {
      return +this.$route.params.id
    },
    id () {
      return +this.$route.params.idClase
    }
  },
  components: {
    'materiales-curso-lista' : MaterialesLista,
    'evaluaciones-curso-lista' : EvaluacionesLista
  },
  created () {
  },
  mounted () {
    if (this.id) {
      this.fetchClase()
    } else {
      this.fetchUltimoOrden()
    }
  },
  methods: {
    volver () {
      var vm = this
      vm.$router.push('/gestion-cursos/' + vm.idCurso)
    },
    fetchClase () {
      var vm = this
      vm.isLoadingClase = true
      const { idCurso } = vm
      apiGet(vm, '/curso/gestion/' + idCurso + '/clase/' + vm.id, {}, function (data) {
        const { titulo, descripcion, orden, linkYT, duracion, activo } = data.clase
        vm.titulo      = titulo
        vm.descripcion = descripcion
        vm.orden       = orden
        vm.linkYT      = linkYT
        vm.duracion    = duracion
        vm.activo      = activo
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.volver()
      }, function () {
        vm.isLoadingClase = false
      })
    },
    fetchUltimoOrden () {
      var vm = this
      vm.isLoadingClase = true
      const { idCurso } = vm
      apiGet(vm, '/curso/gestion/' + idCurso + '/clase/' + vm.id + '/ultimo-orden', { }, function (data) {
        vm.orden = data.orden
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.volver()
      }, function () {
        vm.isLoadingClase = false
      })
    },
    saveMaterial () {
      this.guardarClase(true)
    },
    saveEvaluacion () {
      this.guardarClase(null, true)
    },
    guardarClase (toMaterial, toEvaluacion) {
      if (this.linkYT) {
        if (!this.isValidYouTubeURL(this.linkYT)) {
          notify(this, 'error', 'Error', 'No es un link válido.')
          return
        }
        if (!this.duracion) {
          notify(this, 'error', 'Error', 'Debe escribir la duración del video.')
          return
        }
      }
      if (!this.titulo) {
        notify(this, 'error', 'Error', 'Ingrese el título de la clase.')
        return
      }
      if (this.id) {
        this.actualizarClase()
      } else {
        this.insertarClase(toMaterial, toEvaluacion)
      }
    },
    insertarClase (toMaterial, toEvaluacion) {
      var vm = this
      var obj = {
        titulo      : vm.titulo,
        descripcion : vm.descripcion,
        orden       : vm.orden,
        linkYT      : vm.linkYT,
        duracion    : vm.duracion,
        activo      : vm.activo
      }
      apiPost(vm, `/curso/gestion/${vm.idCurso}/clase/0`, obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Nueva clase guardado correctamente')
        vm.$router.push('/gestion-cursos/' + vm.idCurso + '/gestion-clases/' + data.id)
        vm.fetchClase()
        if (toMaterial) vm.$refs.materialesRef.abrirModalEditar()
        if (toEvaluacion) vm.$refs.evaluacionesRef.abrirModalEditar()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    actualizarClase () {
      var vm = this
      var obj = {
        titulo      : vm.titulo,
        descripcion : vm.descripcion,
        orden       : vm.orden,
        linkYT      : vm.linkYT,
        duracion    : vm.duracion,
        activo      : vm.activo
      }
      apiPut(vm, `/curso/gestion/${vm.idCurso}/clase/${vm.id}`, obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Clase actualizada correctamente')
        vm.fetchClase()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    isValidYouTubeURL () {
      const regex = /^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|playlist\?list=|.+\?v=)?([a-zA-Z0-9_-]{11})?(\S*)?$/;
      return regex.test(this.linkYT)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .textarea
    height auto
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width 400px)
    .is-mobile
      display block

    .is-desktop
      display none
  @media (max-width: 500px)
    .caja
      width: 100%;
    .data
      .usuario
        width: 100%;
        max-width: 100%;
        min-width: 100%;
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
</style>




// WEBPACK FOOTER //
// View_Gestion_Clases_Editar.vue?e1c7c972